"use strict";
'use es6';

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _classCallCheck2 = _interopRequireDefault(require("@babel/runtime/helpers/classCallCheck"));

var _createClass2 = _interopRequireDefault(require("@babel/runtime/helpers/createClass"));

var _apiClient = _interopRequireDefault(require("hub-http/clients/apiClient"));

var BASE_URI = 'blog-settings/v1/blogs';

var ContentGroupsManager = /*#__PURE__*/function () {
  function ContentGroupsManager() {
    (0, _classCallCheck2.default)(this, ContentGroupsManager);
  }

  (0, _createClass2.default)(ContentGroupsManager, [{
    key: "fetch",
    value: function fetch() {
      var query = {
        limit: 300,
        property: ['id', 'name', 'slug']
      };
      return _apiClient.default.get(BASE_URI, {
        query: query
      }).then(function (resp) {
        return resp.objects;
      });
    }
  }]);
  return ContentGroupsManager;
}();

exports.default = ContentGroupsManager;
module.exports = exports.default;